import { Link } from "react-router-dom";
import { Hotel } from "lucide-react";
import "./hp-theme.css";

const NAVY = "#14304F";
const CORAL = "#F26749";

const NAV = [
  ["Discover", "/hotelspulse/stays"],
  ["Destinations", "/hotelspulse/stays"],
  ["Stay Types", "/hotelspulse#stay-types"],
  ["Direct Offers", "/hotelspulse/stays"],
  ["For Hotels", "/hotelspulse#for-hotels"],
  ["How It Works", "/hotelspulse#how-it-works"],
];

/** HotelsPulse.pro brand strip — shown on every HotelsPulse page. */
export const HPHeader = () => (
  <div className="border-b hp-border hp-paper sticky top-0 z-40" data-testid="hp-header">
    <div className="max-w-7xl mx-auto px-5 lg:px-8 py-3 flex items-center justify-between gap-4">
      <Link to="/hotelspulse" data-testid="hp-logo" className="flex items-center gap-2 shrink-0">
        <span className="w-8 h-8 rounded-full flex items-center justify-center text-white" style={{ background: NAVY }}><Hotel className="w-4 h-4" /></span>
        <span className="hp-display font-bold text-lg" style={{ color: NAVY }}>HotelsPulse<span className="text-teal-700">.pro</span><sup className="text-[9px] text-slate-400">™</sup></span>
      </Link>
      <div className="hidden lg:flex items-center gap-5 text-sm font-600 text-slate-600">
        {NAV.map(([label, to]) => (
          <Link key={label} to={to} className="hover:text-teal-700 whitespace-nowrap">{label}</Link>
        ))}
      </div>
      <div className="flex items-center gap-2">
        <Link to="/hotelspulse/dashboard" data-testid="nav-list-property" className="hidden sm:inline-block border rounded-full px-4 py-1.5 text-sm font-700 transition-colors whitespace-nowrap hover:bg-white" style={{ borderColor: NAVY, color: NAVY }}>List Your Property</Link>
        <Link to="/hotelspulse/stays" data-testid="nav-find-stay" className="rounded-full px-4 py-1.5 text-sm font-700 text-white transition-opacity hover:opacity-90 whitespace-nowrap" style={{ background: CORAL }}>Find a Stay</Link>
      </div>
    </div>
  </div>
);
